<frog-landing-toolbar></frog-landing-toolbar>
<div class="root">
    <div class="flex row odd">
        <div class="flex column">
            <div class="flex row align-center justify-center feature-block">
                <div>
                    <h4></h4>
                    <h1>TERMS OF SERVICE</h1>
                    <h4>Last updated September 2, 2022</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="middle flex justify-center">
        <div class="flex-80">
            <!-- BEGIN TOS -->
            <p>
                IMPORTANT: PLEASE READ THESE TERMS OF SERVICE CAREFULLY. THESE TERMS OF SERVICE
                GOVERN (I) THE USE OF FROGEYE.IO (THE “WEBSITE”), AND APPLY TO ALL USERS USING THE
                WEBSITE IN ANY WAY AND (II) THE FROGUBD, LLC (“FROGEYE”, “WE” OR “OUR”) SERVICES,
                SOFTWARE, AND RESOURCES AVAILABLE THROUGH OR ENABLED BY THE WEBSITE (EACH, A
                “SERVICE”). BY CLICKING THE “SIGN UP” BUTTON, CHECKING AN “ACCEPT” BOX, CLICKING THE
                “BUY,” “CONFIRM ORDER,” OR OTHER SIMILAR BUTTON ON OUR ONLINE ORDERING DOCUMENT OR
                ANY APPLICABLE THIRD-PARTY PLATFORM THAT SPECIFIES THE SERVICES (COLLECTIVELY, WITH
                ANY PHYSICALLY EXECUTED ORDER FORMS, THE “ORDER FORM”), COMPLETING THE REGISTRATION
                PROCESS, BROWSING THE WEBSITE, OR OTHERWISE COMMUNICATING YOUR ACCEPTANCE, YOU
                REPRESENT THAT (1) YOU HAVE READ, UNDERSTAND, AND AGREE TO BE BOUND BY THESE TERMS
                OF SERVICE, (2) YOU ARE OF LEGAL AGE AND HAVE FULL LEGAL CAPACITY TO FORM A BINDING
                CONTRACT WITH FROGEYE, AND (3) IF YOU ARE ENTERING INTO THE TERMS OF SERVICE ON
                BEHALF OF AN ENTITY, YOU HAVE THE AUTHORITY TO ENTER INTO THE TERMS OF SERVICE ON
                BEHALF OF THE ENTITY YOU HAVE NAMED AS THE USER, AND TO BIND THAT ENTITY TO THE
                TERMS OF SERVICE. THE TERM “YOU” OR “CUSTOMER” REFERS TO THE INDIVIDUAL OR LEGAL
                ENTITY, AS APPLICABLE, IDENTIFIED AS THE CUSTOMER WHEN YOU REGISTERED THROUGH THE
                SERVICES, OR (IF NONE) ON WHOSE BEHALF THESE TERMS OF SERVICE ARE ACCEPTED, OR (IF
                NONE) WHO ACCEPTS THESE TERMS OF SERVICE DIRECTLY. BY USING THE WEBSITE OR A
                SERVICE, YOU AGREE TO BE BOUND BY THESE TERMS OF SERVICE. TO THE EXTENT CUSTOMER HAS
                SEPARATELY ENTERED INTO A LICENSE OR SUBSCRIPTION AGREEMENT WITH FROGEYE COVERING
                THE SAME SERVICES, THE TERMS AND CONDITIONS OF SUCH AGREEMENT SHALL SUPERSEDE THIS
                AGREEMENT IN ITS ENTIRETY WITH RESPECT TO SUCH SERVICES. IF YOU DO NOT AGREE TO BE
                BOUND BY THESE TERMS OF SERVICE, YOU MAY NOT ACCESS OR USE THE WEBSITE OR THE
                SERVICES.
            </p>
            <p>
                THE “AGREEMENT” SHALL INCLUDE THESE TERMS OF SERVICE, THE ORDER FORM, AND ANY
                DOCUMENTS ATTACHED THERETO. THE TERMS IN ANY PURCHASE ORDER OR WRITTEN PURCHASE
                AUTHORIZATION PROVIDED BY CUSTOMER THAT ADD TO OR CONFLICT WITH OR CONTRADICT ANY
                PROVISION IN THE AGREEMENT WILL HAVE NO LEGAL EFFECT.
            </p>
            <p>
                PLEASE NOTE THAT THESE TERMS OF SERVICE, AND THE TERMS INCORPORATED HEREIN, ARE
                SUBJECT TO CHANGE BY FROGEYE IN ITS SOLE DISCRETION AT ANY TIME. When changes are
                made, FrogEye will make a new copy of the Terms of Service available at the Website.
                FrogEye will also update the “Last Updated” date at the top of the Terms of Service.
                If FrogEye makes any material changes, and you have registered with us to create an
                Account (as defined in Section 3.1 below) FrogEye will also send an email to you at
                the last email address you provided to us pursuant to the Agreement. Any changes to
                the Agreement will be effective immediately for new users and will be effective
                thirty (30) days after posting notice of such changes on the Website for existing
                Registered Users. FrogEye may require you to provide consent to the updated
                Agreement in a specified manner before further use of the Website and/ or the
                Services is permitted. If you do not agree to any change(s) after receiving a notice
                of such change(s), you shall stop using the Website and/or the Services. Otherwise,
                your continued use of the Website and/or Services constitutes your acceptance of
                such change(s). PLEASE REGULARLY CHECK THE WEBSITE TO VIEW THE THEN-CURRENT TERMS.
            </p>
            <h2>1. SaaS Services</h2>
            <h3>1.1. License.</h3>
            <p>
                Subject to the terms and conditions of this Agreement, during the Subscription Term
                (as defined below), FrogEye hereby grants Customer and its subsidiaries a
                non-exclusive, royalty-free, non-transferable, non-sublicensable right, in the
                territory indicated in the Order Form (or on a worldwide basis, if no territory is
                specified), for Customer's authorized employees and independent contractors
                (“Users”) to (a) access and use the Services on a remote basis identified in the
                Order Form, including any software programs and associated interfaces and related
                technology that FrogEye makes available pursuant to this Agreement, in accordance
                with the standard end-user technical documentation, specifications, materials and
                other information FrogEye makes available electronically (the “Documentation”) and
                (b) to use and reproduce a reasonable number of copies of the Documentation, in each
                case, solely for Customer's own internal business purposes. The Order Form may
                contain additional restrictions and limitations to your use of the Services.
            </p>
            <h3>1.2. License Restrictions.</h3>
            <p>
                You agree that you and your subsidiaries will not, and will not permit any User or
                other party to: (a) permit any party to access the Services or Documentation or use
                the Services, other than the Users authorized under this Agreement; (b) modify,
                adapt, alter or translate the Services or Documentation, except as expressly allowed
                herein; (c) sublicense, lease, rent, loan, distribute, or otherwise transfer the
                Services or Documentation to any third party; (d) (other than as and solely to the
                extent, if any, expressly required to be permitted under the laws of your particular
                jurisdiction) reverse engineer, decompile, disassemble, or otherwise derive or
                determine or attempt to derive or determine the source code (or the underlying
                ideas, algorithms, structure or organization) of the Services; (e) use or copy the
                Services or Documentation except as expressly allowed under this Agreement; (f)
                disclose or transmit any data contained in the Services to any individual other than
                a User, except as expressly allowed herein; (g) download or otherwise obtain a copy
                of the Service software; (h) interfere with or disrupt the integrity or performance
                of the Service or attempt to gain unauthorized access to the Service or related
                systems or networks; or (i) use the Service to perform any activity which is or may
                be unlawful, harmful, threatening, abusive, harassing, tortious or defamatory, nor
                perform any activity which breaches the rights of any third party.
            </p>
            <h3>1.3. Free Tier.</h3>
            <p>
                If FrogEye offers, and Customer orders, a free tier or trial version of a Service,
                FrogEye will make that Service available to Customer without charge (the “Free
                Tier”) until the earlier of: (a) the Effective Date of any purchased subscriptions
                for such Services by Customer; or (b) termination by FrogEye in its sole discretion.
                Additional trial terms and conditions may appear on the Website or Order Form. Any
                such additional terms and conditions are incorporated into this Agreement by
                reference and are legally binding.
            </p>

            <h2>2. Acceptable Uses</h2>
            <h3>
                2.1. Usage Rule Generally. You are responsible for all content you provide and your
                activities on the Website and Services.
            </h3>
            <p>
                You may use the Website and Services only in compliance with all applicable laws,
                rules, and regulations, and you may not use them to solicit the performance of any
                activity which infringes our rights or the rights of others.
            </p>
            <h3>2.2 User Submissions.</h3>
            <p>
                “User Submissions” means audio, text, images or other media created or submitted by
                sources other than FrogEye for purposes of sharing or publishing on the Service. You
                understand that when using the Website or any Services, you may be exposed to User
                Submissions from a variety of sources, and that FrogEye is not responsible for the
                accuracy, usefulness, safety, or intellectual property rights of or relating to such
                User Submissions. You further understand and acknowledge that you may be exposed to
                User Submissions that are inaccurate, offensive, indecent, or objectionable. We are
                not liable for any statements or representations in your User Submissions provided
                by you in any area on the Website. You are solely responsible for your User
                Submissions to the Website and you expressly agree to exonerate us from any and all
                responsibility and to refrain from any legal action against us regarding your User
                Submission. We have the right, in our sole and absolute discretion, (1) to edit,
                redact, or otherwise change any User Submissions; (2) to re-categorize any User
                Submissions to place them in more appropriate locations on the Website; and (3) to
                pre-screen or delete any User Submissions at any time and for any reason, without
                notice. We have no obligation to monitor your User Submissions. By providing any
                User Submissions, you represent and warrant as follows: The creation, distribution,
                transmission, public display, or performance, and the accessing, downloading, or
                copying of your User Submissions do not and will not infringe the proprietary
                rights, including but not limited to the copyright, patent, trademark, trade secret,
                or moral rights of any third party. You are the creator and owner of or have the
                necessary licenses, rights, consents, releases, and permissions to use and to
                authorize FrogEye, the Website, the Services, and other users of the Website and
                Services to use your User Submissions in any manner contemplated by the Website and
                these Terms of Service. You have the written consent, release, and/or permission of
                each and every identifiable individual person in your User Submissions to use the
                name or likeness of each and every such identifiable individual person to enable
                inclusion and use of your User Submissions in any manner contemplated by the Website
                and these Terms of Service. Your User Submissions are not false, inaccurate, or
                misleading. Your User Submissions are not unsolicited or unauthorized advertising,
                promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other
                forms of solicitation. Your User Submissions are not obscene, lewd, lascivious,
                filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as
                determined by us). Your User Submissions do not ridicule, mock, disparage,
                intimidate, or abuse anyone. Your User Submissions are not used to harass or
                threaten (in the legal sense of those terms) any other person and to promote
                violence against a specific person or class of people. Your User Submissions do not
                violate any applicable law, regulation, or rule. Your User Submissions do not
                violate the privacy or publicity rights of any third party. Your User Submissions do
                not violate any applicable law concerning child pornography, or otherwise intended
                to protect the health or well-being of minors. Your User Submissions do not include
                any offensive comments that are connected to race, national origin, gender, sexual
                preference, or physical handicap. Your User Submissions do not otherwise violate, or
                link to material that violates, any provision of these Terms of Service, or any
                applicable law or regulation.
            </p>
            <h3>2.3 Automated Access.</h3>
            <p>
                Except as FrogEye may expressly permit, you may not use or launch any automated
                system, including without limitation, “robots,” “spiders,” or “scrapers,” that
                accesses the Website or any Service in a manner that sends more request messages to
                the FrogEye servers in a given period of time than a human can reasonably produce in
                the same period by using a conventional online web browser. Notwithstanding the
                foregoing, FrogEye grants the operators of public web search engines permission to
                use spiders to copy materials from the Website for the sole purpose of and solely to
                the extent necessary for creating publicly available searchable indices of the
                materials, but not caches or archives of such materials. FrogEye may revoke or
                modify these exceptions either generally or in specific cases. You agree not to
                collect or harvest any personally identifiable information from the Website or any
                Service.
            </p>

            <h2>3. Your Account</h2>
            <h3>3.1. General.</h3>
            <p>
                To access the Services, you will be required to become a Registered User. For
                purposes of this Agreement, a “Registered User” is a user who has registered an
                account on the Website (an “Account”).
            </p>
            <h3>3.2. Registration Data.</h3>
            <p>
                In registering an account on the Website, you agree to (a) provide true, accurate,
                current and complete information about yourself as prompted by the registration form
                (the “Registration Data”); and (b) maintain and promptly update the Registration
                Data to keep it true, accurate, current and complete. You represent that you are at
                least eighteen (18) years old, and not barred from using FrogEye's Services under
                the laws of the United States, your place of residence or any other applicable
                jurisdiction. You are responsible for all activities that occur under your Account.
                You agree that you shall monitor your Account to restrict use by minors, and you
                will accept full responsibility for any unauthorized use of the Website and Services
                by minors. You may not share your Account or password with anyone, and you agree to
                notify FrogEye immediately of any unauthorized use of your password or any other
                breach of security. If you provide any information that is untrue, inaccurate, not
                current or incomplete, or if FrogEye has reasonable grounds to suspect that any
                information you provide is untrue, inaccurate, not current or incomplete, FrogEye
                may suspend or terminate your Account and/or refuse any and all current or future
                use of the Website or Services (or any portion thereof). You agree not to create an
                Account using a false identity or information, or on behalf of someone other than
                yourself. FrogEye reserves the right to remove or reclaim any usernames at any time
                and for any reason, including but not limited to, claims by a third party that a
                username violates the third party's rights. You agree not to create an Account or
                use the Website or Services if you have been previously removed by FrogEye, or if
                you have been previously banned from any of FrogEye products or services, including
                without limitation the Website or Services.
            </p>
            <h3>3.3. Your Account.</h3>
            <p>
                Notwithstanding anything to the contrary herein, you acknowledge and agree that you
                shall have no ownership or other property interest in your Account, and you further
                acknowledge and agree that all rights in and to your Account are and shall forever
                be owned by and inure to the benefit of FrogEye. For clarity, this does not grant
                FrogEye ownership of your Customer Data, which is addressed below.
            </p>
            <h3>
                3.4. Necessary Equipment and Software. You must provide all equipment and software
                necessary to connect to the Website and Services.
            </h3>
            <p>
                You are solely responsible for any fees, including Internet connection or mobile
                fees, that you incur when accessing the Website and Services.
            </p>

            <h2>4. Proprietary Rights</h2>
            <h3>4.1. Ownership by FrogEye.</h3>
            <p>
                The Services and Documentation are licensed and not sold to Customer, and no title
                or ownership to such Services, Documentation, or the intellectual property rights
                embodied therein passes as a result of this Agreement or any act pursuant to this
                Agreement. The Website, the Services, Documentation, and all intellectual property
                rights therein (other than the User Submissions and Customer Data itself) are the
                exclusive property of FrogEye and its suppliers, and all rights in and to the
                Website, the Services and Documentation not expressly granted to Customer in this
                Agreement are reserved by FrogEye. FrogEye and its suppliers own all rights, title,
                and interest to the Website, the Services and Documentation. Nothing in this
                Agreement will be deemed to grant, by implication, estoppel or otherwise, a license
                under any existing or future patents of FrogEye, except to the extent necessary for
                Customer to use the Services and Documentation as an end user, as expressly
                permitted under this Agreement. You will not remove, alter or obscure any copyright,
                trademark, service mark or other proprietary rights notices incorporated in or
                accompanying the Website, the Services or the Documentation.
            </p>
            <h3>4.2 Your Content.</h3>
            <p>
                FrogEye does not claim ownership of Your Content. However, when you as a Registered
                User post or publish Your Content on or in Services, you represent that you own
                and/or have a royalty-free, perpetual, irrevocable, worldwide, non-exclusive right
                (including any moral rights) and license to use, license, reproduce, modify, adapt,
                publish, translate, create derivative works from, distribute, derive revenue or
                other remuneration from, and communicate to the public, perform and display Your
                Content (in whole or in part) worldwide and/or to incorporate it in other works in
                any form, media or technology now known or later developed, for the full term of any
                worldwide intellectual property right that may exist in Your Content.
            </p>
            <h3>4.3 License to Your Content.</h3>
            <p>
                Subject to any applicable account settings that you select, you grant FrogEye a
                fully paid, royalty-free, perpetual, irrevocable, worldwide, royalty-free,
                non-exclusive and fully sublicensable right (including any moral rights) and license
                to use, license, distribute, reproduce, modify, adapt, publicly perform, and
                publicly display Your Content (in whole or in part) for the purposes of operating
                and providing Services to you and to our other Registered Users. Please remember
                that other Registered Users may search for, see, use, modify and reproduce any of
                Your Content that you submit to any “public” area of Services. You warrant that the
                holder of any worldwide intellectual property right, including moral rights, in Your
                Content, has completely and effectively waived all such rights and validly and
                irrevocably granted to you the right to grant the license stated above. You agree
                that you, not FrogEye, are responsible for all of Your Content that you Make
                Available on or in Services.
            </p>
            <h3>4.3 Customer Data.</h3>
            <p>
                “Customer Data” consists of data and other information you make available to us
                through your use of the Services under these Terms of Service, other than User
                Submissions. The terms of our <a href="/privacy">Privacy Policy</a> shall apply when
                personal data is being processed pursuant to this Agreement. You instruct us to use
                and disclose Customer Data as necessary to (a) provide the Services consistent with
                FrogEye's <a href="/privacy">Privacy Policy</a>, Section 5, and this Section 4.3,
                including detecting, preventing, and investigating security incidents, fraud, spam,
                or unlawful use of the Services, and (b) respond to any technical problems or your
                queries and ensure the proper working of the Services. You acknowledge that the
                Internet and telecommunications providers' networks are inherently insecure.
                Accordingly, you agree FrogEye is not liable for any changes to, interception of, or
                loss of Customer Data while in transit via the Internet or a telecommunications
                provider's network.
            </p>
            <h3>4.4. Trademarks.</h3>
            <p>
                FrogEye, the frog eye logo, and all related graphics, logos, service marks and trade
                names used on or in connection with Website or in connection with the Services are
                the trademarks of FrogEye and may not be used without permission in connection with
                your, or any third-party, products or services. Other trademarks, service marks and
                trade names that may appear on or in the Website or the Services are the property of
                their respective owners.
            </p>
            <h3>4.5. Feedback.</h3>
            <p>
                You hereby grant to FrogEye a royalty-free, worldwide, transferable, sublicensable,
                irrevocable, perpetual license to use or incorporate into the Services or any other
                products or services of FrogEye, any suggestions, enhancement requests,
                recommendations or other feedback provided by you, including Users, relating to the
                Services. FrogEye will not identify you or Users as the source of any such feedback.
            </p>

            <h2>5. Confidentiality</h2>
            <h3>5.1. Confidential Information. Subject to Section 5.</h3>
            <p>
                3, all information disclosed by one party (“Disclosing Party”) to the other party
                (the “Receiving Party”) during the term of this Agreement, whether oral, written,
                graphic or electronic (the “Confidential Information”) shall be considered
                Confidential Information of the Disclosing Party. The Services, Documentation, and
                all enhancements and improvements thereto shall be Confidential Information of
                FrogEye. All data provided by Customer to FrogEye to enable provision and
                performance of the Services, other than your and your Users' User Submissions, shall
                be Customer's Confidential Information.
            </p>
            <h3>5.2. Protection of Confidential Information.</h3>
            <p>
                The Receiving Party will not use any Confidential Information of the Disclosing
                Party for any purpose not permitted by this Agreement, and will disclose the
                Confidential Information of the Disclosing Party only to employees or contractors of
                the Receiving Party who have a need to know such Confidential Information for
                purposes of this Agreement and are under a duty of confidentiality no less
                restrictive than the Receiving Party's duty hereunder. The Receiving Party will
                protect the Disclosing Party's Confidential Information from unauthorized use,
                access, or disclosure in the same manner as the Receiving Party protects its own
                confidential or proprietary information of a similar nature and with no less than
                reasonable care.
            </p>
            <h3>5.3. Exceptions.</h3>
            <p>
                The Receiving Party's obligations under Section 5.2 with respect to Confidential
                Information of the Disclosing Party will not apply to any information that: (a) was
                already known to the Receiving Party at the time of disclosure by the Disclosing
                Party; (b) is disclosed to the Receiving Party by a third party who had the right to
                make such disclosure without any confidentiality restrictions; (c) is, or through no
                fault of the Receiving Party has become, generally available to the public; or (d)
                is independently developed by the Receiving Party without access to, or use of, the
                Disclosing Party's Confidential Information. In addition, the Receiving Party will
                be allowed to disclose Confidential Information of the Disclosing Party to the
                extent that such disclosure is (i) approved in writing by the Disclosing Party, (ii)
                necessary for the Receiving Party to enforce its rights under this Agreement in
                connection with a legal proceeding; or (iii) required by law or by the order or a
                court of similar judicial or administrative body, provided that the Receiving Party
                notifies the Disclosing Party of such required disclosure promptly and in writing
                and cooperates with the Disclosing Party, at the Disclosing Party's reasonable
                request and expense, in any lawful action to contest or limit the scope of such
                required disclosure.
            </p>

            <h2>6. Professional Services; Support</h2>
            <h3>6.1. Professional Services.</h3>
            <p>
                If separately agreed upon by the parties in an Order Form, FrogEye shall provide
                Customer with certain professional services, including without limitation,
                implementation and training services (the “Professional Services”). FrogEye shall
                have no obligation to provide such Professional Services unless specified in an
                Order Form.
            </p>
            <h3>6.2. Support and Maintenance.</h3>
            <p>
                Support and maintenance services, if any, will be subject to the terms and
                conditions of a separate written agreement. These Terms of Service do not obligate
                FrogEye to provide any support or maintenance services.
            </p>

            <h2>7. Term and Termination</h2>
            <h3>
                7.1. Term. These Terms of Service remain in effect until terminated according to
                Section 7.2.
            </h3>
            <p>
                With respect to the remainder of the Agreement, the initial term will begin on the
                effective date specified on the Order Form (the “Effective Date”) and continue in
                full force and effect for the period indicated on the Order Form (the “Initial
                Subscription Term”), unless terminated earlier in accordance with Section 7.2.
                Unless otherwise specified in an Order Form, the Agreement will automatically renew
                for successive periods equal to the Initial Subscription Term or one year (whichever
                is shorter) (the “Renewal Subscription Terms”), unless either party gives the other
                written notice (email acceptable) at least thirty (30) days before the end of the
                relevant term. The “Subscription Term” shall mean the Initial Subscription Term and
                any Renewal Subscription Terms.
            </p>
            <h3>7.2. Termination of Agreement.</h3>
            <p>
                Either party may terminate this Agreement for material breach by the other party,
                which remains uncured thirty (30) days after delivery of written notice of such
                breach to the breaching party ten (10) days if such breach is in connection with
                non-payment). Notwithstanding the foregoing, FrogEye may immediately terminate this
                Agreement and all licenses granted hereunder if Customer breaches Section 1 or 2
                hereof. The foregoing rights of termination are in addition to any other rights and
                remedies provided in this Agreement or by law.
            </p>
            <h3>7.3. Effect of Termination.</h3>
            <p>
                Termination of this Agreement with respect to any Service includes removal of
                Customer's access to such Service and the termination of any applicable licenses or
                rights. Termination of the Agreement or all Services may also include deletion of
                your Account and all related information associated with or inside your Account (or
                any part thereof). FrogEye will not have any liability whatsoever to you for any
                suspension or termination.
            </p>
            <h3>7.4. Survival. Sections 1.</h3>
            <p>2, 2, 4, 5, 7.3, 7.4, and 8-13 will survive the termination of this Agreement.</p>
            <h2>8. Fees</h2>
            <h3>8.1. Fees and Payment Terms.</h3>
            <p>
                Customer shall pay FrogEye the fees as set forth on the applicable Order Form (the
                “Fees”). FrogEye shall send invoices to Customer based on the invoice schedules set
                forth on the applicable Order Form. If Customer's use of the Services exceeds any
                limitations applicable to Customer's subscription tier (such as number of users or
                storage space), or otherwise requires the payment of additional fees per the terms
                of this Agreement, FrogEye may invoice Customer for such additional usage and
                Customer agrees to pay the additional Fees in the manner provided herein. All
                payments shall be made in U.S. dollars. Unless otherwise specified in the applicable
                Order Form, Customer will pay all Fees payable to FrogEye within thirty (30) days
                following the receipt by Customer of an invoice from FrogEye. Late payments will
                accrue interest at the rate of one and one-half percent (1.5%) per month, or if
                lower, the maximum rate permitted under applicable law. FrogEye reserves the right
                to increase Fees with thirty (30) days' prior written notice to Customer; provided
                that no such increase shall apply to an existing Subscription Term. Additional
                payment terms may be set forth in the Order Form. FrogEye reserves the right to
                suspend the Services in whole or in part if any Fees are over thirty (30) days late.
            </p>
            <h3>8.2. Payment Service Vendors.</h3>
            <p>
                We may use Stripe, Inc. (“Stripe”) and/or another third-party vendor for payment
                services (e.g., card acceptance, merchant settlement, and related services). By
                using the Services, you: (a) agree to be bound by
                <a href="https://www.stripe.com/privacy">Stripe's Privacy Policy</a>, and/or any
                additional terms offered by the vendor or displayed in connection with your payment;
                and (b) hereby consent and authorize FrogEye and Stripe (and/or our other applicable
                third-party vendor) to share any information and payment instructions you provide
                with one or more third-party service providers, to the minimum extent required to
                complete your transactions.
            </p>
            <h3>8.3. Taxes.</h3>
            <p>
                All fees are exclusive of any sales, use, excise, withholding, import, export or
                value-added tax, levy, duty or similar governmental charge which may be assessed
                based on any payment due hereunder, including any related penalties and interest
                (“Taxes”). Customer is solely responsible for all Taxes resulting from transactions
                under this Agreement, except Taxes based on FrogEye's net income. Customer will
                indemnify and hold FrogEye harmless from (a) the Customer's failure to pay (or
                reimburse FrogEye for the payment of) all such Taxes; and (b) the imposition of and
                failure to pay (or reimburse FrogEye for the payment of) all governmental permit
                fees, license fees, customs fees and similar fees levied upon delivery of the
                Services or Documentation which FrogEye may incur in respect of this Agreement or
                any other fees required to be made by Customer under this Agreement, together with
                any penalties, interest, and collection or withholding costs associated therewith.
            </p>

            <h2>9. Disclaimers of Warranties</h2>
            9.1. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW AND EXCEPT AS EXPRESSLY STATED
            OTHERWISE HEREIN, THE WEBSITE, SERVICES, ANY IMPLEMENTATION OR PROFESSIONAL SERVICES OR
            SUPPORT, DOCUMENTATION AND ANY OTHER PRODUCT OR SERVICE PROVIDED TO CUSTOMER ARE
            PROVIDED “AS IS” AND “AS AVAILABLE.” FROGEYE HEREBY DISCLAIMS ALL WARRANTIES WHETHER
            EXPRESS, IMPLIED OR STATUTORY WITH RESPECT TO THE WEBSITE, THE SERVICES, DOCUMENTATION,
            ANY PROFESSIONAL SERVICES OR SUPPORT SERVICES, AND ANY OTHER PRODUCTS OR SERVICES
            PROVIDED TO CUSTOMER UNDER THIS AGREEMENT, INCLUDING WITHOUT LIMITATION ANY IMPLIED
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
            NON-INFRINGEMENT, AND ANY WARRANTY ARISING OUT OF COURSE OF PERFORMANCE, COURSE OF
            DEALING OR USAGE OF TRADE. 9.2. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING,
            NEITHER FROGEYE NOR ANY OF ITS SUPPLIERS ASSUMES ANY RESPONSIBILITY FOR THE SECURITY,
            TIMELINESS, DELETION, MIS-DELIVERY OR FAILURE TO STORE OR TRANSMIT ANY DATA IN, FROM OR
            TO THE SERVICES. FURTHERMORE, NOTHING STATED IN THIS AGREEMENT WILL IMPLY THAT THE
            OPERATION OF THE services OR ITS INTEROPERABILITY WITH ANY OTHER SOFTWARE OR SERVICES
            WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE, OR THAT ERRORS WILL BE CORRECTED.
            NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY FROGEYE OR ANY OF ITS SUPPLIERS SHALL
            IN ANY WAY INCREASE THE SCOPE OF FROGEYE'S WARRANTIES OR OBLIGATIONS UNDER THIS
            AGREEMENT.
            <h2>10. Indemnification</h2>
            <h3>10.1. By FrogEye.</h3>
            <h3>10.1.1.</h3>
            <p>
                FrogEye's Obligation. Subject to the terms and conditions of Section 10, FrogEye
                will defend any suit brought against Customer by a third party to the extent that
                the suit is based upon a claim that the Customer's permitted use of a Service
                infringes such third party's United States copyrights or misappropriates such third
                party's trade secrets recognized as such under the Defend Trade Secrets Act, and
                FrogEye will pay those costs and damages finally awarded against Customer in any
                such action or those costs and damages agreed to in a monetary settlement of such
                claim, in each case that are specifically attributable to such claim. However, such
                defense and payments are subject to the conditions that: (a) FrogEye will be
                notified promptly in writing by Customer of any such claim; (b) FrogEye will have
                sole control of the defense and all negotiations for any settlement or compromise of
                such claim; and (c) Customer will cooperate and, at FrogEye's request and expense,
                assist in such defense. This Section 10.1 states FrogEye's entire liability and
                Customer's sole and exclusive remedy for any infringement and/or misappropriation
                claims.
            </p>
            <h3>10.1.2.</h3>
            <p>
                Alternative. If Customer's use of the Services is prevented by injunction or court
                order because of infringement, or should the Services be likely to become the
                subject of any claim in FrogEye's sole opinion, Customer will permit FrogEye, at the
                sole discretion of FrogEye and no expense to Customer, to: (i) procure for Customer
                the right to continue using such Services in accordance with this Agreement; or (ii)
                replace or modify the Services so that it becomes non-infringing while providing
                substantially similar features. Where (i) and (ii) above are not commercially
                feasible for FrogEye, the applicable licenses will terminate upon notice from
                FrogEye to Customer, and FrogEye will refund to Customer pre-paid fees on a
                pro-rated basis for the remainder of the term to Customer.
            </p>
            <h3>10.1.3.</h3>
            <p>
                Exclusions. FrogEye will have no liability to Customer for any claim of infringement
                or misappropriation to the extent based upon: (a) use of the Services not in
                accordance with this Agreement or the Documentation; (b) the combination of the
                Services with third-party hardware or software not conforming to the operating
                environment specified in Documentation; (c) any modification of the Services by any
                person other than FrogEye; (d) Free Tier or other unpaid Services; (e) Customer
                Data; or (f) User Submissions submitted by parties other than you or your Users.
                Customer will indemnify FrogEye against all liability, damages and costs (including
                reasonable attorneys' fees) resulting from any claims described in clauses (a)
                through (e) of this Section 10.1.3.
            </p>
            <h3>10.2. By Customer.</h3>
            <p>
                Except for claims against which FrogEye must defend Customer under Section 10.1,
                Customer will indemnify, defend and hold FrogEye and its directors, officers,
                affiliates, members, shareholders, employees, agents, partners, licensors, and
                suppliers harmless from and against any and all actual or alleged third-party claims
                and accompanying liabilities, losses, damages, costs and expenses, including
                reasonable external attorneys' fees arising out of or in connection with, (a)
                Customer's or any User's use of, or inability to use the Services; (b) Customer's or
                any User's violation of this Agreement; (c) Customer's or any User's violation of
                any rights of another party, including any Registered Users; (d) Customer's or
                User's violation of any applicable laws, rules, or regulations; or (e) Customer
                Data, including any User Submissions input into the Services by or on behalf of
                Customer or any User, including claims that such data or materials violates or
                infringes the privacy or intellectual property rights of a third party.
            </p>

            <h2>11. Limitation of Liability</h2>
            <h3>
                11.1. TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL FROGEYE BE LIABLE TO
                CUSTOMER OR ANY OTHER PARTY FOR ANY SPECIAL, PUNITIVE, INDIRECT, INCIDENTAL,
                EXEMPLARY, OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR RELATED TO THIS AGREEMENT, OR
                ANY SERVICES OR PROFESSIONAL SERVICES PROVIDED HEREIN, UNDER ANY LEGAL THEORY,
                INCLUDING, BUT NOT LIMITED TO, LOSS OF DATA, LOSS OF THE USE OR PERFORMANCE OF ANY
                PRODUCTS OR SERVICES, LOSS OF REVENUES, LOSS OF PROFITS, OR BUSINESS INTERRUPTION,
                EVEN IF FROGEYE KNOWS OF OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES. TO
                THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL FROGEYE'S TOTAL CUMULATIVE
                LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT EXCEED THE GREATER OF (A) TEN
                DOLLARS ($10), OR (B) THE TOTAL AMOUNT OF FEES RECEIVED BY FROGEYE FROM CUSTOMER
                UNDER THIS AGREEMENT DURING THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING SUCH CLAIM.
                THIS SECTION 11 WILL APPLY EVEN IF AN EXCLUSIVE REMEDY OF CUSTOMER UNDER THIS
                AGREEMENT HAS FAILED OF ITS ESSENTIAL PURPOSE.
            </h3>
            <h3>
                11.2. THE LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE
                BASIS OF THE BARGAIN BETWEEN FROGEYE AND CUSTOMER.
            </h3>
            <p></p>
            <h2>12. General</h2>

            <h3>12.1. Release.</h3>
            <p>
                Except for claims against which FrogEye must defend you under Section 10.1, you
                hereby release FrogEye and its successors from claims, demands, any and all losses,
                damages, rights, and actions of any kind, including personal injuries, death, and
                property damage, that is either directly or indirectly related to or arises from
                your use of the Website or the Services. To the extent applicable to you, you hereby
                waive California Civil Code Section 1542, which states, “A general release does not
                extend to claims that the creditor or releasing party does not know or suspect to
                exist in his or her favor at the time of executing the release and that, if known by
                him or her, would have materially affected his or her settlement with the debtor or
                released party,” and any similar laws with respect to future or unknown claims under
                the laws of any other applicable jurisdiction. The foregoing release does not apply
                to any claims, demands, or any losses, damages, rights and actions of any kind,
                including personal injuries, death or property damage for any unconscionable
                commercial practice by FrogEye or for FrogEye's fraud in connection with the Website
                or any Services provided hereunder.
            </p>
            <h3>12.2. Electronic Communications.</h3>
            <p>
                The communications between you and FrogEye may take place via electronic means,
                whether you visit the Website or Services or send FrogEye emails, or whether FrogEye
                posts notices on the Website or Services or communicates with you via email. For
                contractual purposes, you (a) consent to receive communications from FrogEye in an
                electronic form; and (b) agree that all terms and conditions, agreements, notices,
                disclosures, and other communications that FrogEye provides to you electronically
                satisfy any legal requirement that such communications would satisfy if it were to
                be in writing.
            </p>
            <h3>12.3. Notice.</h3>
            <p>
                Where FrogEye requires that you provide an email address, you are responsible for
                providing FrogEye with your most current email address. If the last email address
                you provided to FrogEye is not valid, or for any reason is not capable of delivering
                to you any notices required/ permitted by the Agreement, FrogEye's dispatch of the
                email containing such notice will nonetheless constitute effective notice. You may
                give notice of any changes to your email address to FrogEye at the following
                address:
                <a href="mailto:dmca@frogeye.io">info&#64;frogeye.io</a>.
            </p>
            <h3>12.4. Relationship of Parties.</h3>
            <p>
                The parties hereto are independent contractors. Nothing in this Agreement will be
                deemed to create an agency, employment, partnership, fiduciary or joint venture
                relationship between the parties.
            </p>
            <h3>12.5. Publicity.</h3>
            <p>
                Upon request to Customer, FrogEye may use Customer's name, logo and a description of
                Customer's use of the Services for investor relations and marketing purposes.
            </p>

            <h3>12.6. Compliance with Export Control Laws and Anti-Corruption.</h3>
            <h3>12.6.1.</h3>
            <p>
                Export Control. Customer acknowledges that the Services are subject to export
                control and sanctions laws, including without limitation the U.S. Export
                Administration Regulations administered by the U.S. Department of Commerce's Bureau
                of Industry and Security (“BIS”) and economic sanctions administered by the U.S.
                Department of the Treasury's Office of Foreign Assets Control (“OFAC”), and other
                similar national or international laws and regulations (collectively, “Export
                Laws”). Customer agrees to comply with all Export Laws related to Customer's use of
                the Services. Customer represents and warrants that it is not (i) located,
                organized, or resident in a country or territory that is subject to a U.S. trade
                embargo; or (ii) identified on, or owned or controlled by any party identified on,
                any applicable sanctions or restricted party list, including the Specially
                Designated Nationals and Blocked Persons List, Foreign Sanctions Evaders List, and
                Sectoral Sanctions Identifications List, administered by OFAC, and the Entity List,
                Denied Persons List, or Unverified List, administered by BIS. Customer agrees that
                it will not export, re-export or otherwise transfer the Services, or use the
                Services to disclose, transfer, download, export or re-export, directly or
                indirectly, any Customer Data, to any country, entity or other party that is
                ineligible to receive such items under the Export Laws. Customer will defend,
                indemnify, and hold harmless FrogEye from and against all fines, penalties,
                liabilities, damages, costs and expenses (including reasonable attorneys' fees)
                incurred by FrogEye as a result of Customer's breach of this Section 12.6.1.
            </p>
            <h3>12.6.2.</h3>
            <p>
                Anti-Corruption. Customer warrants that neither Customer, nor any of Customer's
                respective officers, employees, agents, representatives, contractors, intermediaries
                or any other person or entity acting on Customer's behalf, in connection with this
                Agreement, has taken or will take any action, directly or indirectly, in violation
                of the U.S. Foreign Corrupt Practices Act of 1977, as amended, or any other
                applicable anti-corruption or anti-bribery laws.
            </p>
            <h3>12.7. Assignment.</h3>
            <p>
                Customer may not assign or transfer, by operation of law, merger or otherwise, any
                of its rights or delegate any of its duties under this Agreement (including, without
                limitation, its licenses and rights in connection with the Services) to any third
                party without FrogEye's prior written consent. Any attempted assignment or transfer
                in violation of the foregoing will be null and void. FrogEye may assign its rights
                or delegate its obligations under this Agreement without consent.
            </p>
            <h3>12.8. Governing Law and Venue.</h3>
            <p>
                This Agreement will be governed by the laws of the State of Texas, excluding any
                conflict of law provisions that would require the application of the laws of any
                other jurisdiction. The United Nations Convention on Contracts for the International
                Sale of Goods shall not apply to this Agreement. Any action or proceeding arising
                from or relating to this Agreement must be brought exclusively in the appropriate
                state court located in Fort Bend County, Texas or federal court located in Harris
                County, Texas, in either case having subject-matter jurisdiction over such action or
                proceeding. Each party irrevocably consents to the exclusive personal jurisdiction
                and venue in, and agrees to service of process issued by, any such court.
            </p>
            <h3>12.9. Force Majeure.</h3>
            <p>
                Any delay in or failure of performance by either party under this Agreement, other
                than a failure to pay amounts when due, will not be considered a breach of this
                Agreement and will be excused to the extent caused by any occurrence beyond the
                reasonable control of such party, including, but not limited to, acts of God, war,
                terrorism, riots, embargos, acts of civil or military authorities, fire, floods,
                accidents, dels or shortages of transportation facilities, fuel, energy, labor or
                materials.
            </p>
            <h3>12.10. Remedies.</h3>
            <p>
                Except as expressly provided elsewhere in this Agreement, the parties' rights and
                remedies under this Agreement are cumulative. Customer acknowledges that the
                Services contains valuable trade secrets and proprietary information of FrogEye,
                that any actual or threatened breach of Section 1 (Grant and Scope of License) or
                Section 4 (Confidentiality) will constitute immediate, irreparable harm to FrogEye
                for which monetary damages would be an inadequate remedy, and that injunctive relief
                is an appropriate remedy for such breach.
            </p>

            <h3>12.11. Waiver; Severability.</h3>
            <p>
                Any waiver or failure to enforce any provision of this Agreement on one occasion
                will not be deemed a waiver of any other provision or of such provision on any other
                occasion. If any provision of this Agreement is adjudicated to be unenforceable,
                such provision will be changed and interpreted to accomplish the objectives of such
                provision to the greatest extent possible under applicable law and the remaining
                provisions will continue in full force and effect.
            </p>
            <h3>12.12. Order of Precedence; Construction.</h3>
            <p>
                In the event of any conflict or inconsistency among the following documents, the
                order of precedence shall be: (1) the applicable Order Form (2) this Agreement. The
                Section headings of this Agreement are for convenience and will not be used to
                interpret this Agreement. As used in this Agreement, the word “including” means
                “including but not limited to.”
            </p>
            <h2>13. Copyright Policy</h2>
            <p>
                FrogEye respects the intellectual property rights of others, and expects its users
                to do the same. FrogEye will respond expeditiously to claims of copyright
                infringement committed using the Website or Services if such claims are reported to
                FrogEye's Designated Copyright Agent identified below.
            </p>
            <p>
                If you are a copyright owner, authorized to act on behalf of one, or authorized to
                act under any exclusive right under copyright, please report alleged copyright
                infringements taking place on or through the Website by completing the following
                DMCA Notice of Alleged Infringement and delivering it to FrogEye's Designated
                Copyright Agent. Upon receipt of Notice as described below, FrogEye will take
                whatever action, in its sole discretion, it deems appropriate, including removal of
                the challenged content from the Website.
            </p>
            <p>DMCA Notice</p>
            <p>
                If you believe that your copyrighted work has been copied in a way that constitutes
                copyright infringement and is accessible via the FrogEye Website, please notify
                FrogEye's copyright agent, as set forth in the Digital Millennium Copyright Act of
                1998 (“DMCA”). For your complaint to be valid under the DMCA, you must provide the
                following information in writing:
            </p>
            <p>
                An electronic or physical signature of a person authorized to act on behalf of the
                copyright owner; identification of the copyrighted work or works that you claim has
                been infringed; identification of the material that is claimed to be infringing and
                where it is located on or in the Services, or a representative list of such works if
                you intend to cover multiple works in a single notice; information reasonably
                sufficient to permit FrogEye to contact you, such as your address, telephone number,
                and, e-mail address; a statement that you have a good faith belief that use of the
                material in the manner complained of is not authorized by the copyright owner, its
                agent, or law; and a statement, made under penalty of perjury, that the information
                you have submitted is accurate, and that you are the copyright owner or are
                authorized to act on behalf of the owner.
            </p>
            <p>The above information must be submitted to the following DMCA Agent:</p>
            <p>Attn: FrogEye DMCA Notice</p>
            <p><a href="mailto:dmca@frogeye.io">dmca&#64;frogeye.io</a></p>
            <p>
                UNDER U.S. FEDERAL LAW, IF YOU KNOWINGLY MISREPRESENT THAT ONLINE MATERIAL IS
                INFRINGING, YOU MAY BE SUBJECT TO CRIMINAL PROSECUTION FOR PERJURY AND CIVIL
                PENALTIES, INCLUDING MONETARY DAMAGES, COURT COSTS, AND ATTORNEYS' FEES.
            </p>
            <p>
                Please note that this procedure is exclusively for notifying FrogEye that your
                copyrighted material has been infringed. The preceding requirements are intended to
                comply with FrogEye's rights and obligations under the DMCA, including but not
                limited to 17 U.S.C. §512(c), but do not constitute legal advice. It may be
                advisable to contact an attorney regarding your rights and obligations under the
                DMCA and other applicable laws.
            </p>

            <!-- END TOS -->
        </div>
    </div>

    <frog-footer></frog-footer>
</div>
